import * as React from 'react';

import { Grid, Typography2 } from '@coursera/cds-core';

import LearningObjective from 'bundles/enterprise-learning-path-description-page/modules/LearningObjective';
import TrackedDiv from 'bundles/page/components/TrackedDiv';
import Subsection from 'bundles/unified-description-page-common/components/shared/Subsection';

import _t from 'i18n!nls/xdp';

type Props = {
  learningObjectives: string[];
  moduleSpacing?: number;
  checkSize?: 'small' | 'large';
};

const LearningObjectives = ({ learningObjectives, moduleSpacing, checkSize }: Props) => {
  if (!learningObjectives.length) {
    return null;
  }

  return (
    <Subsection
      title={
        <Typography2 variant="subtitleLarge" component="h2">
          {_t("What you'll learn")}
        </Typography2>
      }
      spacing={moduleSpacing || 24}
    >
      <TrackedDiv
        trackingName="what_you_will_learn_section"
        withVisibilityTracking={true}
        requireFullyVisible={false}
        trackClicks={false}
      >
        <Grid container spacing={16} component="ul">
          {learningObjectives.map((objective, index) => {
            return (
              // eslint-disable-next-line react/no-array-index-key
              <Grid item xs={12} sm={6} key={index} component="li">
                <LearningObjective objective={objective} checkSize={checkSize} />
              </Grid>
            );
          })}
        </Grid>
      </TrackedDiv>
    </Subsection>
  );
};

export default LearningObjectives;
